export default "__VITE_ASSET__D5N4hjQf__"